import React from 'react';
import { toPersianNum } from 'utils/helpers';
import { TitleProps } from './Title.props';
import './style.scss';

const Title = React.memo<TitleProps>(({ title, date, meal }) => {
	return (
		<div className="title-wrapper">
			<h3 className="title">{title}</h3>
			<p className="sub-title">
				<span>{date && toPersianNum(date)}</span>{' '}
				{meal && (
					<>
						- <span data-testid='TitleComponent__meal'>{meal}</span>
					</>
				)}
			</p>
		</div>
	);
});

export default Title;
